import _ from "lodash";

/**
 * @param errors The errors array returned from JSON API SPEC
 *
 * @returns A formatted string with error details with new line separating them
 */
export default (error) => {
    const { errors } = error;

    if (errors) {
        const msg = [];
        _.forEach(errors, (err) => {
            msg.push(
                err.title.replace(/\n/g, " - ") ||
                    (error.source &&
                        error.source.pointer &&
                        `${_.last(_.split(err.source.pointer, "/")) + err.title}`) ||
                    "Unknown error happened"
            );
        });
        return msg.join("\r\n");
    }
    return "Unknown error happened";
};
